import React, { useState } from 'react';
import { Search, Filter, MapPin, Users } from 'lucide-react';
import { companies } from '../../data/mockData';
interface CompanyDirectoryProps {
  tenantId: string;
  onNavigate: (page: string, id?: string) => void;
}
export function CompanyDirectory({
  tenantId,
  onNavigate
}: CompanyDirectoryProps) {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedIndustry, setSelectedIndustry] = useState<string | null>(null);
  const tenantCompanies = companies.filter(c => c.tenantId === tenantId);
  const industries = Array.from(new Set(tenantCompanies.map(c => c.industry))).sort();
  const filteredCompanies = tenantCompanies.filter(c => {
    const matchesSearch = c.name.toLowerCase().includes(searchTerm.toLowerCase()) || c.description.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesIndustry = selectedIndustry ? c.industry === selectedIndustry : true;
    return matchesSearch && matchesIndustry;
  });
  return <div className="space-y-6" data-id="element-579">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-580">
        <div className="relative w-full md:w-96" data-id="element-581">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={18} data-id="element-582" />
          <input type="text" placeholder="Unternehmen suchen..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full pl-10 pr-4 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500 outline-none shadow-sm" data-id="element-583" />
        </div>

        <div className="flex items-center gap-2 overflow-x-auto pb-2 md:pb-0 w-full md:w-auto hide-scrollbar" data-id="element-584">
          <button onClick={() => setSelectedIndustry(null)} className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${selectedIndustry === null ? 'bg-slate-800 text-white' : 'bg-white border border-slate-200 text-slate-600 hover:bg-slate-50'}`} data-id="element-585">
            Alle Branchen
          </button>
          {industries.slice(0, 4).map(ind => <button key={ind} onClick={() => setSelectedIndustry(ind)} className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${selectedIndustry === ind ? 'bg-slate-800 text-white' : 'bg-white border border-slate-200 text-slate-600 hover:bg-slate-50'}`} data-id="element-586">
              {ind}
            </button>)}
          <button className="px-3 py-2 bg-white border border-slate-200 text-slate-600 rounded-full hover:bg-slate-50 transition-colors flex items-center gap-1" data-id="element-587">
            <Filter size={14} data-id="element-588" />
            <span className="text-sm font-medium" data-id="element-589">Mehr</span>
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-590">
        {filteredCompanies.map(company => <div key={company.id} onClick={() => onNavigate('company-profile', company.id)} className="bg-white rounded-xl border border-slate-200 shadow-sm hover:shadow-md transition-all cursor-pointer group flex flex-col h-full" data-id="element-591">
            <div className="p-6 flex-1" data-id="element-592">
              <div className="flex items-start justify-between mb-4" data-id="element-593">
                <div className="w-12 h-12 rounded-xl bg-slate-50 border border-slate-100 flex items-center justify-center text-2xl shadow-sm" data-id="element-594">
                  {company.logo}
                </div>
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-slate-100 text-slate-600" data-id="element-595">
                  {company.industry}
                </span>
              </div>

              <h3 className="text-lg font-bold text-slate-900 mb-2 group-hover:text-emerald-600 transition-colors line-clamp-1" data-id="element-596">
                {company.name}
              </h3>
              <p className="text-sm text-slate-500 line-clamp-2 mb-4" data-id="element-597">
                {company.description}
              </p>

              <div className="flex flex-wrap gap-2 mt-auto" data-id="element-598">
                {company.services.slice(0, 2).map((service, i) => <span key={i} className="px-2 py-1 bg-emerald-50 text-emerald-700 text-xs font-medium rounded" data-id="element-599">
                    {service}
                  </span>)}
                {company.services.length > 2 && <span className="px-2 py-1 bg-slate-50 text-slate-500 text-xs font-medium rounded" data-id="element-600">
                    +{company.services.length - 2}
                  </span>}
              </div>
            </div>

            <div className="px-6 py-4 border-t border-slate-100 bg-slate-50/50 rounded-b-xl flex items-center justify-between text-sm text-slate-500" data-id="element-601">
              <div className="flex items-center gap-1.5" data-id="element-602">
                <Users size={16} className="text-slate-400" data-id="element-603" />
                <span data-id="element-604">{company.employeeCount} MA</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-605">
                <span className="w-2 h-2 rounded-full bg-emerald-500" data-id="element-606"></span>
                <span data-id="element-607">
                  Partner seit {new Date(company.memberSince).getFullYear()}
                </span>
              </div>
            </div>
          </div>)}
      </div>

      {filteredCompanies.length === 0 && <div className="text-center py-12 bg-white rounded-xl border border-slate-200" data-id="element-608">
          <Building2 size={48} className="mx-auto text-slate-300 mb-4" data-id="element-609" />
          <h3 className="text-lg font-bold text-slate-900 mb-1" data-id="element-610">
            Keine Unternehmen gefunden
          </h3>
          <p className="text-slate-500" data-id="element-611">
            Passen Sie Ihre Suche oder Filter an.
          </p>
        </div>}
    </div>;
}